// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"bb3ecdce","537":"bb3ecdce"}[chunkId] + ".chunk.css";
};